import React from 'react';
import {
    Flex,
    Text,
    ChooseDropdown,
    DropdownSelectTrigger
} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';
import {SELECT_COMPANY_DIALOG} from './consts';
import {isRTL} from '../../Localization';
import {createDataTestId} from '../../utils/dataTestId';

export const SearchableList = ({
    label,
    options,
    currValue,
    onSelect,
    dataTestId,
    maxScrollHeight = null
}) => {
    return (
        <Flex
            direction="column"
            alignItems="flex-start"
            componentClasses={styles.searchListWrapper}
            {...createDataTestId(dataTestId, true)}
        >
            <Text skin="label-1">{label}</Text>
            <ChooseDropdown
                width={460}
                isRtl={isRTL()}
                data={options}
                usePortal
                portalSelector={SELECT_COMPANY_DIALOG}
                onChange={item => onSelect(item)}
                hasSearch
                trigger={<DropdownSelectTrigger placeholder={currValue || ''} />}
                maxScrollHeight={maxScrollHeight}
            />
        </Flex>
    );
};
